/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
import React, { Fragment } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { Scrollbars } from 'react-custom-scrollbars-2';
import AccountIcon from 'mdi-react/AccountIcon';
import PhoneIcon from 'mdi-react/PhoneIcon';
import BullhornIcon from 'mdi-react/BullhornIcon';
import LaptopIcon from 'mdi-react/LaptopIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import avatarDefault from '../../../shared/img/avatar-default.jpg';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

const headCells = [
  { id: 'name', numeric: false, disablePadding: true, label: 'Ejecutivo', sorting: true },
  { id: 'status', numeric: false, disablePadding: false, label: 'Estado', sorting: true },
  { id: 'opened_cases', numeric: true, disablePadding: false, label: 'Casos Abiertos', sorting: true },
  { id: 'closed_cases', numeric: true, disablePadding: false, label: 'Casos Cerrados', sorting: true },
  { id: 'pending_cases', numeric: true, disablePadding: false, label: 'Casos Pendientes', sorting: true },
  { id: 'within_term_cases', numeric: true, disablePadding: false, label: 'Dentro de Plazo', sorting: true },
  { id: 'late_cases', numeric: true, disablePadding: false, label: 'Fuera de Plazo', sorting: true },
  { id: 'origin', numeric: true, disablePadding: false, label: 'Origen', sorting: false },
  { id: 'queries', numeric: true, disablePadding: false, label: 'Consultas', sorting: true },
  { id: 'requests', numeric: true, disablePadding: false, label: 'Solicitudes', sorting: true },
  { id: 'claims', numeric: true, disablePadding: false, label: 'Reclamos', sorting: true }
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = property => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {
              headCell.sorting
                ? (
                  <Fragment>
                    <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : 'asc'}
                      onClick={createSortHandler(headCell.id)}
                    >
                      {headCell.label}
                      {orderBy === headCell.id ? (
                        <span className="hidden">
                          {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  </Fragment>
                )
                : headCell.label
            }
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

function ExecutivesStatisticsComponent(props) {
  const { body } = props;
  const [order, setOrder] = React.useState(props.order);
  const [orderBy, setOrderBy] = React.useState(props.orderBy);
  const handleRequestSort = (_event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  let rows = [];
  if (body) {
    rows = body;
  }
  return (
    <div className="section-content">
      <Scrollbars className="table-scrollbar" style={{ width: '100%' }} autoHeight autoHeightMax={1000} autoHide>
        <Table className="table-data">
          <EnhancedTableHead
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
          />
          <TableBody>
            {stableSort(rows, getComparator(order, orderBy))
              .map((row, index) => {
                const labelId = `enhanced-table-checkbox-${index}`;
                return (
                  <TableRow
                    key={row.name}
                  >
                    <TableCell component="th" id={labelId} scope="row">
                      {
                        row.avatar && row.avatar.length > 0
                          ? (
                            <React.Fragment>
                              <div className="avatar">
                                <img src={row.avatar} alt={row.name} />
                              </div>
                            </React.Fragment>
                          )
                          : (
                            <React.Fragment>
                              <div className="avatar">
                                <img src={avatarDefault} alt={row.name} />
                              </div>
                            </React.Fragment>
                          )
                      }
                      {row.name}
                    </TableCell>
                    <TableCell className="status">
                      {
                        row.status
                          ? <div className="label active"><span />Activo</div>
                          : <div className="label inactive"><span />Inactivo</div>
                      }
                    </TableCell>
                    <TableCell>{row.opened_cases}</TableCell>
                    <TableCell>{row.closed_cases}</TableCell>
                    <TableCell>{row.pending_cases}</TableCell>
                    <TableCell>{row.within_term_cases}</TableCell>
                    <TableCell>{row.late_cases}</TableCell>
                    <TableCell className="origin web">
                      <span><LaptopIcon size={17} />{row.web_cases}</span>
                      <span><EmailIcon size={17} />{row.email_cases}</span>
                      <span><AccountIcon size={17} />{row.face_cases}</span>
                      <span><PhoneIcon size={17} />{row.phone_cases}</span>
                      <span><BullhornIcon size={17} />{row.referred_cases}</span>
                    </TableCell>
                    <TableCell>{row.queries}</TableCell>
                    <TableCell>{row.requests}</TableCell>
                    <TableCell>{row.claims}</TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </Scrollbars>
    </div>
  );
}

export default ExecutivesStatisticsComponent;
